import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Defaults to localStorage for web
import rootReducer from './reducers/rootReducer';
import loginLoggerMiddleware from './middleware/loginLogger';

// Persist config for redux-persist
const persistConfig = {
  key: 'root',
  storage, // Use localStorage
  whitelist: ['auth' , 'franchise','userPreferences'], // Only persist the auth reducer
};

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, 
    }).concat(loginLoggerMiddleware),
});

// Create a persistor
export const persistor = persistStore(store);

export default store;
